var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallArrowGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230.62117 367.81185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_28);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_28",
    x1: 148.51252,
    y1: 84.40377,
    x2: -54.86812,
    y2: 287.7844,
    gradientTransform: "matrix(1, 0, 0, -1, -0.00003, 370.00002)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01457,
    stopColor: "#0091f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10856,
    stopColor: "#00aed3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#00c7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31881,
    stopColor: "#00dc98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43773,
    stopColor: "#00eb83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57184,
    stopColor: "#00f775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73381,
    stopColor: "#00fd6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff6a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow thin color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.95,150.6531,79.97055,13.67373a47.01673,47.01673,0,0,0-66.29681,0l-.00006.00006a47.01685,47.01685,0,0,0,0,66.2968L117.60905,183.9059,13.67368,287.84127a47.01684,47.01684,0,0,0,0,66.29681l.00006.00006a47.01672,47.01672,0,0,0,66.2968,0L216.95,217.15877A47.27649,47.27649,0,0,0,216.95,150.6531Z",
    transform: "translate(0 -0.00001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrowGradient);
export default __webpack_public_path__ + "static/media/small-arrow-gradient.e6729cedaa211741982a0121b4529da0.svg";
export { ForwardRef as ReactComponent };